import React, { useEffect } from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from 'leaflet';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import factoryIconUrl from '../../media/factory.png';


// Factory icon for the map marker
const factoryIcon = new L.Icon({
    iconUrl: factoryIconUrl,
    iconSize: [70, 70],
    iconAnchor: [35, 70],
    popupAnchor: [0, -32],
});

// Component to adjust the center of the map
const AdjustMapCenter = ({ latitude, longitude }) => {
    const map = useMap();

    useEffect(() => {
        if (latitude && longitude) {
            const [newLat, newLng] = offsetCenter(map, latitude, longitude, 20, 10);
            map.setView([newLat, newLng], 13, { animate: true, duration: 1 });
        }
    }, [latitude, longitude, map]);

    return null;
};

// Function to calculate new center based on an offset
const offsetCenter = (map, lat, lng, xPercent, yPercent) => {
    if (!map) return [lat, lng];

    const mapSize = map.getSize();
    if (mapSize) return [lat, lng];
    const xOffset = (xPercent / 100) * mapSize.x;
    const yOffset = (yPercent / 100) * mapSize.y;

    const targetPoint = map.latLngToContainerPoint([lat, lng]);
    const newPoint = L.point(targetPoint.x - xOffset, targetPoint.y - yOffset);
    const newLatLng = map.containerPointToLatLng(newPoint);

    return [newLatLng.lat, newLatLng.lng];
};

const MapComponent = ({
    center = [13.0843, 80.2705],
    zoom = 25,
    hasMarkerLocation = false,
    MarkerPopup = null,
    onMarkerClick,
    onToggleSidebar,
    onOpenFilter,
    showSidebarToggle = false,
}) => {
    return (
        <MapContainer
            zoomControl={false}
            center={center}
            zoom={zoom}
            style={{
                height: '100%',
                width: '100%',
            }}
            scrollWheelZoom
        >
            <Box direction={'column'} p={2} sx={{ maxWidth: '60px' }}>
                {showSidebarToggle && (
                    <Tooltip title="Open Results">
                        <IconButton
                            sx={{
                                background: 'white',
                                boxShadow: 3,
                                '&:hover': {
                                    background: 'white',
                                },
                                zIndex: 1000,
                                transition: 'left 0.3s ease-in-out',
                            }}
                            onClick={onToggleSidebar}
                            color="primary"
                        >
                            <SwapHorizontalCircleIcon />
                        </IconButton>
                    </Tooltip>
                )}

                <Tooltip title="Inspection filters">
                    <IconButton
                        sx={{
                            background: 'white',
                            boxShadow: 3,
                            '&:hover': {
                                background: 'white',
                            },
                            zIndex: 1000,
                            transition: 'left 0.3s ease-in-out',
                            marginTop: 1,
                        }}
                        onClick={onOpenFilter}
                        color="warning"
                    >
                        <FilterAltIcon color="warning" />
                    </IconButton>
                </Tooltip>
            </Box>

            <AdjustMapCenter latitude={center[0]} longitude={center[1]} />
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {hasMarkerLocation && <Marker

                icon={factoryIcon}
                position={center}
                eventHandlers={{
                    click: () => null,
                    // click: () => onMarkerClick(marker),
                }}
            >
                <Popup className="custom-popup">
                    {MarkerPopup}
                </Popup>
            </Marker>}
        </MapContainer>
    );
};

export default MapComponent;